import { Box, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import IconButton from "../Button/IconButton";
import SwitchButton from "../Button/SwitchButton";

/**
 * Cell Renderers
 * Pure functions that return JSX for rendering table cells
 * These can be reused across different tables
 */

export const textRenderer = (value) => (
  <Typography variant="body2">{value || "-"}</Typography>
);

export const nestedValueRenderer = (path) => (value, row) => {
  const keys = path.split(".");
  const nestedValue = keys.reduce((obj, key) => obj?.[key], row) ?? "-";
  return <Typography variant="body2">{nestedValue}</Typography>;
};

export const jsonBoxRenderer = (dataKey, onViewClick) => (value, row) => {
  const data = dataKey ? row[dataKey] : value;
  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        padding: "8px 10px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#EEEEEE",
          borderColor: "#BDBDBD",
        },
        maxWidth: "400px",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap",
        overflowWrap: "break-word",
      }}
      onClick={() => onViewClick && onViewClick(data)}
    >
      <Typography
        variant="caption"
        sx={{
          fontFamily: "Courier New, monospace",
          fontSize: "0.875rem",
          color: "#424242",
          display: "block",
          lineHeight: "1.4",
        }}
      >
        {/* {JSON.stringify(data)} */}
        {JSON.stringify(data, null, 2)}
      </Typography>
    </Box>
  );
};

export const actionButtonsRenderer = (actions) => (value, row) =>
  (
    // <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center" }}>
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {actions.map((action) => {
        const {
          id,
          icon: IconComponent,
          tooltip,
          variant = "info",
          onClick,
          condition,
          variantIfFalse,
          type,
          stateKey,
        } = action;

        // Skip rendering if condition is provided and evaluates to false
        if (condition && !condition(row)) {
          return null;
        }

        // Render Switch type actions
        if (type === "switch") {
          const finalTooltip =
            typeof tooltip === "function" ? tooltip(row) : tooltip;
          const isChecked = stateKey ? row[stateKey] : false;

          return (
            <SwitchButton
              key={id}
              checked={isChecked}
              onChange={() => onClick(row)}
              tooltip={finalTooltip}
              size="small"
            />
          );
        }

        const finalVariant =
          condition && !condition(row) ? variantIfFalse : variant;
        const finalTooltip =
          typeof tooltip === "function" ? tooltip(row) : tooltip;

        return (
          <Tooltip key={id} title={finalTooltip} arrow>
            <span>
              <IconButton
                variant={
                  typeof finalVariant === "function"
                    ? finalVariant(row)
                    : finalVariant
                }
                size="small"
                // icon={<IconComponent />}
                icon={IconComponent ? <IconComponent /> : null}
                // onClick={() => onClick(row)}
                onClick={() => onClick && onClick(row)}
              />
            </span>
          </Tooltip>
        );
      })}
    </Box>
  );

export const fullActionsRenderer = (onEdit, onToggle, onDelete) =>
  actionButtonsRenderer([
    {
      id: "edit",
      icon: EditIcon,
      tooltip: "Edit this spec",
      variant: "primary",
      onClick: (row) => onEdit(row),
    },
    // {
    //   id: "toggle",
    //   icon: PowerSettingsNewIcon,
    //   tooltip: (row) =>
    //     row.enabled ? "Disable this spec" : "Enable this spec",
    //   variant: (row) => (row.enabled ? "success" : "disabled"),
    //   onClick: (row) => onToggle(row),
    // },
    {
      id: "toggle",
      type: "switch",
      stateKey: "enabled",
      tooltip: (row) =>
        row.enabled ? "Disable this spec" : "Enable this spec",
      onClick: (row) => onToggle(row),
    },
    {
      id: "delete",
      icon: DeleteIcon,
      tooltip: "Delete this spec",
      variant: "danger",
      onClick: (row) => onDelete(row),
    },
  ]);
